import {
  createBreakpointConverter
} from "./chunk.MIOPVZYG.js";

// src/components/box/box.types.ts
var spaceSizes = [
  "xxx-small",
  "xx-small",
  "x-small",
  "small",
  "medium",
  "large",
  "x-large",
  "xx-large",
  "xxx-large",
  "xxxx-large",
  "none"
];
var spacingProperties = ["p", "pt", "pr", "pb", "pl", "ph", "pv", "m", "mt", "mr", "mb", "ml", "mh", "mv"];
var SpacePropertyConverter = createBreakpointConverter(spaceSizes);
var spaceSizeTokenMap = {
  none: "none",
  "xxx-small": "3x-small",
  "xx-small": "2x-small",
  "x-small": "x-small",
  small: "small",
  medium: "medium",
  large: "large",
  "x-large": "x-large",
  "xx-large": "2x-large",
  "xxx-large": "3x-large",
  "xxxx-large": "4x-large"
};
var displayTypes = ["block", "inline", "inline-block", "flex", "inline-flex"];
var DisplayPropertyConverter = createBreakpointConverter(displayTypes);

export {
  spaceSizes,
  spacingProperties,
  SpacePropertyConverter,
  spaceSizeTokenMap,
  displayTypes,
  DisplayPropertyConverter
};
